export default {
  data() {
    return {
      columns: [
        {
          title: '序号',
          width: 70,
          dataIndex: 'order',
          fixed: 'left',
          customRender: (text, record, index) =>
            (this.pageData.current - 1) * this.pageData.pageSize + (index + 1),
        },
        {
          width: 200,
          title: '事件',
          dataIndex: 'id',
        },
        {
          width: 200,
          title: '机构名称',
          dataIndex: 'bureauName',
        },
        {
          width: 200,
          title: '产品名称',
          dataIndex: 'productName',
        },
        {
          width: 200,
          title: '状态',
          dataIndex: 'statusStr',
        },
        {
          width: 200,
          title: '提交时间',
          dataIndex: 'createTime',
        },
        {
          width: 200,
          title: '完成时间',
          dataIndex: 'updateTime',
        },
        {
          width: 200,
          title: '操作',
          dataIndex: 'action',
          slotName: 'action',
          scopedSlots: { customRender: 'action' },
        },
        {
          width: 200,
          title: '信息',
          dataIndex: 'message',
        },
      ],
      searchSchema: [
        {
          label: '机构名称',
          itemName: 'bureauName',
          type: 'select',
          selectList: [
            {
              text: 'Dun & Bradstreet Global',
              value: '1',
            },
            {
              text: 'Credit Risk Monitor',
              value: '2',
            },
            {
              text: '安华理达',
              value: '3',
            },
            {
              text: '中诚信',
              value: '4',
            },
          ],
          allowClear: true,
          handleChange: this.ProductNameList,
        },
        {
          label: '产品名称',
          itemName: 'productName',
          type: 'select',
          selectList: [],
          allowClear: true,
        },
        {
          label: '状态',
          itemName: 'status',
          type: 'select',
          selectList: [
            {
              text: '成功',
              value: '1',
            },
            {
              text: '失败',
              value: '2',
            },
            {
              text: '处理中',
              value: '3',
            },
          ],
          allowClear: true,
        },
      ],
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
      },
      searchData: {
        bureauName: '',
        status: '',
        productName: '',
      },
    }
  },
}
